module.exports = __webpack_public_path__ + "img/icon-question.f0f88d7a.svg";